import { render, staticRenderFns } from "./ComprobanteAsociado.vue?vue&type=template&id=27b5caf0&"
import script from "./ComprobanteAsociado.vue?vue&type=script&lang=js&"
export * from "./ComprobanteAsociado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports